<template>
  <div class="contract-agreement-wrap">
    <cooperation-detail-head-cp
      v-show="sticky"
      :mainContractInfo="false"
    ></cooperation-detail-head-cp>
    <div class="contract-agreement-info" @click="handAgreementContract">
      <span>所属合同：</span>
      <span>{{ mainContract }}</span>
    </div>
    <div class="tabs-box" id="cooperation-detail-container-tabs-box-id">
      <van-tabs
        v-model="active"
        color="#36C490"
        title-inactive-color="#000"
        title-active-color="#36C490"
      >
        <van-tab title="产值申报" v-if="reportAuth">
          <report-detail></report-detail>
        </van-tab>
        <van-tab title="付款申请" v-if="payAuth">
          <pay-detail></pay-detail>
        </van-tab>
        <van-tab title="签证变更" v-if="visaAuth">
          <visa-detail></visa-detail>
        </van-tab>
        <van-tab title="合同结算" v-if="accountsAuth">
          <accounts-detail></accounts-detail>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import cooperationDetailHeadCp from './cooperation-packge/components/cooperation-detail-head-cp';
import visaDetail from './cooperation-packge/cooperation-visa-detail';
import accountsDetail from './cooperation-packge/cooperation-accounts-detail';
import payDetail from './cooperation-packge/cooperation-pay-detail';
import reportDetail from './cooperation-packge/cooperation-report-detail';
import { getUrlParams } from 'common/js/mUtils';
import { Tab, Tabs } from 'vant';
import { mapState } from 'vuex';

export default {
  components: {
    cooperationDetailHeadCp,
    visaDetail,
    accountsDetail,
    payDetail,
    reportDetail,
    'van-tabs': Tabs,
    'van-tab': Tab
  },
  data() {
    return {
      sticky: true,
      tabsData: [
        {
          name: '产值申报',
          active: 0
        },
        {
          name: '付款申请',
          active: 1
        },
        {
          name: '签证变更',
          active: 2
        },
        {
          name: '合同结算',
          active: 3
        }
      ],
      mainContractGuid: '',
      mainContract: '',
      watertext: '',
      watermobile: '',
      active: '0'
    };
  },
  props: {
    index: {
      type: String,
      default: '0'
    }
  },
  created() {
    let { mainContract, mainContractGuid } = this.$route.query;
    let { employeeName, mobile } = getUrlParams();
    this.watertext = decodeURIComponent(employeeName) || '';
    this.watermobile = mobile;
    this.mainContract = mainContract;
    this.mainContractGuid = mainContractGuid;
  },
  computed: mapState({
    reportAuth: state => state.reportAuth,
    payAuth: state => state.payAuth,
    visaAuth: state => state.visaAuth,
    accountsAuth: state => state.accountsAuth
  }),
  methods: {
    handAgreementContract() {
      let { employeeName, mobile } = getUrlParams();
      let { mainContract, mainContractGuid } = this;
      this.$router.push({
        name: 'cooperationDetail',
        query: {
          contractguid: mainContractGuid,
          index: 0,
          mainContract,
          mainContractGuid,
          employeeName: decodeURIComponent(employeeName),
          mobile
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.contract-agreement-wrap {
  position: relative;
  z-index: 9;
  .contract-agreement-info {
    display: flex;
    padding-left: 20px;
    padding-top: 32px;
    span:nth-child(1) {
      color: #999;
      line-height: 1.5;
      display: inline-block;
      width: 1.4rem;
    }
    span:nth-child(2) {
      color: #666;
      line-height: 1.5;
      flex: 1;
    }
  }
  .tabs-box {
    margin-top: 20px;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: 1s;
    opacity: 1;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>
